<template>
  <div
    class="lottie-widget"
    :style="style"
  >
    <lottie-player
      :key="widget.content"
      class="player"
      :src="widget.content"
      :autoplay="true"
      :loop="widget.loop"
    />
  </div>
</template>

<script>

export default {
  name: 'LottieWidgetView',
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  computed: {
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        height: `${this.widget.height}px`,
        width: `${this.widget.width}px`,
        zIndex: this.widget.zIndex,
        transform: `rotate(${this.widget.rotate}deg)`,
        borderRadius: this.widget.borderRadius,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.lottie-widget {
  position: absolute;
  display: flex;
  .player {
    background: transparent;
    height: 100%;
  }
}
</style>
